var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96408 1.60595H3.85693C3.91586 1.60595 3.96408 1.55773 3.96408 1.49881V1.60595H8.03551V1.49881C8.03551 1.55773 8.08372 1.60595 8.14265 1.60595H8.03551V2.57023H8.99979V1.49881C8.99979 1.02604 8.61542 0.641663 8.14265 0.641663H3.85693C3.38417 0.641663 2.99979 1.02604 2.99979 1.49881V2.57023H3.96408V1.60595ZM10.7141 2.57023H1.28551C1.04845 2.57023 0.856934 2.76175 0.856934 2.99881V3.42738C0.856934 3.48631 0.905148 3.53452 0.964076 3.53452H1.77301L2.10381 10.539C2.12524 10.9957 2.50292 11.3559 2.95961 11.3559H9.03997C9.49801 11.3559 9.87435 10.997 9.89577 10.539L10.2266 3.53452H11.0355C11.0944 3.53452 11.1426 3.48631 11.1426 3.42738V2.99881C11.1426 2.76175 10.9511 2.57023 10.7141 2.57023ZM8.93685 10.3917H3.06274L2.73863 3.53452H9.26095L8.93685 10.3917Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.657b57141ff756cdab489cc52321553a.svg";
export { ForwardRef as ReactComponent };